// src/store.ts
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/authSlice";
import orderSliceReducer from "../slices/kontrolEdge/orderSlice";
import sideMenuReducer from "../slices/sideMenuSlice";
import userProfileReducer from "../slices/userProfileSlice";
import portReducer from "../slices/kontrolEdge/portSlice";
import productReducer from "../slices/productSlice"
import connectionReducer from "../slices/kontrolEdge/connectionSlice"
import datacenterReducer from "../slices/kontrolEdge/datacenterSlice"
import backboneDetailsReducer from "../slices/kontrolEdge/backboneDetailsSlice";
import selectionReducer from "../slices/tenantSlice";
import userEditorReducer from "../slices/userEditorSlice";
import userListReducer from "../slices/usersListSlice";
import tenantNoticesReducer from "../slices/tenantNoticesSlice";
import maintenanceReducer from "../slices/maintenanceSlice";
import notificationsV2GroupsReducer from "../slices/notificationsV2/groupsSlice";
import networkAlertsReducer from "../slices/networkAlertsSlice";
import archiReducer from "../slices/archiSlice";
import tagsManagerFiltersReducer from "../slices/tagsManagerFiltersSlice";
import notificationsV2AccountReducer from "../slices/notificationsV2AccountSlice";
import notificationsGroupsFiltersReducer from "../slices/notificationsGroupsFiltersSlice";
import insightScopeReducer from "../slices/insightScopeSlice";

// Importamos redux-persist
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

const rootReducer = combineReducers({
  auth:        authReducer,
  order:       orderSliceReducer,
  sideMenu:    sideMenuReducer,
  userProfile: userProfileReducer,
  port:        portReducer,
  product:     productReducer,
  connection:  connectionReducer,
  datacenter:  datacenterReducer,
  backboneDetails: backboneDetailsReducer,
  selection:   selectionReducer,
  userEditor: userEditorReducer,
  userList: userListReducer,
  tenantNotices: tenantNoticesReducer,
  maintenance: maintenanceReducer,
  notificationsV2Groups: notificationsV2GroupsReducer,
  networkAlerts: networkAlertsReducer,
  archi: archiReducer,
  tagsManagerFilters: tagsManagerFiltersReducer,
  notificationsV2Account: notificationsV2AccountReducer,
  notificationsGroupsFilters: notificationsGroupsFiltersReducer,
  insightScope: insightScopeReducer,
});


// Config de persist
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["selection"], //slice saved
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
